import { EApprovalStatus } from "./approval.type";
import { FileProperties } from "./file.type";
import { ListingProperties } from "./listing.type";
import { AgentPortalProfileProps, OfficePortalProfileProps } from "./portalProfile.type";

export enum EOfficeStatus {
	OPEN = "OPEN",
	PUBLISH = "PUBLISH",
	UNPUBLISH = "UNPUBLISH",
	INACTIVE = "INACTIVE",
}

export type OfficeProperties = {
	officeId: string;
	areaCode: string;
	officeCode?: string;
	fixCodeCreatedAt?: Date;
	tempOfficeCode?: string;
	tempCodeCreatedAt?: Date;
	subdomain?: string;
	webMetaTitle?: string;
	webMetaDesc?: string;
	webMetaTitleEn?: string;
	webMetaDescEn?: string;
	officeName: string;
	denyDuplicateListing?: boolean;
	province: string;
	city: string;
	postalCode?: string;
	status: EOfficeStatus;
	firstPhoneNumber: string;
	secondPhoneNumber?: string;
	email?: string;
	address: string;
	npwp?: string;
	isOfficePkp: boolean;
	financeName?: string;
	financeEmail?: string;
	financePhone?: string;
	approvalStatus: EApprovalStatus;
	createdByUserId: string;
	createdByUserMeta?: any;
	actionByUserId?: string;
	actionByUserMeta?: any;
	actionRemark?: string;
	metadata?: any;
	lastUpdateByMeta?: any;
	createdAt?: Date;
	updatedAt?: Date;
	logo?: FileProperties;
	npwpFile?: FileProperties;
	checkDefaultFee: string;

	officePortalProfiles?: OfficePortalProfileProps[];
	agentPortalProfiles?: AgentPortalProfileProps[];
};

export type ListOfficeQuery = {
	filterOfficeId?: string;
	filterApprovalStatus?: string;
	filterStatus?: string;
	filterAreaCode?: string;
	filterCreatedByUserId?: string;
	filterSubdomain?: string;
	filterActionStartAt?: string;
	filterActionEndAt?: string;
	includeData?: string;
	filterDefaultFee?: string;
	sort?: string;
};

export type OfficeHistoryProperties = {
	officeHistoryId: string;
	officeId: string;
	action: string;
	actionByUserId?: string;
	actionByMeta?: any;
	actionRoleUser?: string;
	remark?: string;
	newData?: any;
	clientId?: string;
	clientVersion?: string;
	createdAt: Date;
	updatedAt: Date;
};
